export class SessionStorageConstants {
  static PREVIOUS_PATH = 'previousPath';
  static SESSION_VALID = 'isSessionValid';
  static GLOBAL_SEARCH = {
    PREVIOUS_SEARCH_STATE : 'previousSearchState'
  };
}
